import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { PuntoVentaModel, StartShiftModel } from "../models/StartShiftModel";
import {
  getAllPuntosVenta,
  getAllShiftSupplier,
  getAllSuppliersClosed,
  obtenerPVPorIDService,
  startDaySupplier,
} from "../../../service/start_shift/StartShift";
import { SimpleAlert } from "../../../../rbts/helpers";
import { SelectFormat } from "../../../../rbts/helpers/models/GenericModel";

export const useGetAllShiftSupplier = (reload: number) => {
  const [shiftList, setShiftList] = useState<StartShiftModel[]>([]);
  const [loadingRequest, setLoadingRequest] = useState<boolean>(true);
  const history = useHistory();

  useEffect(() => {
    const fetchPost = async () => {
      const res = await getAllShiftSupplier()
        .then()
        .catch((error) => {
          history.push("/error/500");
        });
      if (res) {
        setShiftList(res.rows);
        setLoadingRequest(false);
      }
    };
    fetchPost();
  }, [reload]);

  return { shiftList, loadingRequest };
};

export const useExecuteStarShiftSuplier = () => {
  const [loadingRequest, setLoadingRequest] = useState<boolean>(false);

  const startDay = async (supplierId: number) => {
    setLoadingRequest(true);
    try {
      await startDaySupplier(supplierId);
      setLoadingRequest(false);
      SimpleAlert("Se ha iniciado el turno correctamente", 3000, "success");
    } catch (err: any) {
      setLoadingRequest(false);
      let resMessageToast: string = "";
      if (err.response && err.response.data && err.response.data.message) {
        resMessageToast = err.response.data.message;
      } else {
        resMessageToast =
          "Hubo un problema para iniciar turno, intentalo nuevamente.";
      }
      SimpleAlert(resMessageToast, 3000, "error");
      throw resMessageToast;
    }
  };

  return { startDay, loadingRequest };
};

export const useSelectSuppliersClosed = () => {
  const [suppliers, setSuppliers] = useState<SelectFormat[]>([]);
  const [loadingRequest, setLoadingRequest] = useState<boolean>(true);
  const history = useHistory();
  let arr: any = [];

  useEffect(() => {
    const fetchPost = async () => {
      const res = await getAllSuppliersClosed()
        .then()
        .catch((error) => {
          history.push("/error/500");
        });
      if (res) {
        setSuppliers(res);
        setLoadingRequest(false);
      }
    };

    fetchPost();
  }, []);

  return { suppliers, loadingRequest };
};



export const useObtenerPVPorID = (id: number) => {
  const initModel: PuntoVentaModel = {
    id: 0,
    nombre: '',
    tipo: 'PUESTO',
    banco: 0,
    punto_venta: 100,
    productos: [],
    is_supply_available: true,
    is_app_visible: true,
  };
  const [initValues, setInitValues] = useState<any>(initModel);
  const [loadingRequest, setLoadingRequest] = useState<boolean>(true);

  const history = useHistory();
  useEffect(() => {
    const fetchPost = async () => {
      setLoadingRequest(true);
      const res = await obtenerPVPorIDService(id)
        .then()
        .catch((error) => {
          history.push("/error/500");
        });

      if (res) {
        setInitValues(res);
        setLoadingRequest(false);
      }
    };
    if (id > 0) {
      fetchPost();
    } else {
      setInitValues(initModel);
      setLoadingRequest(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return { initValues, loadingRequest };
};

export const useGetAllPuntosVenta = (reload: number) => {
  const [shiftList, setShiftList] = useState<PuntoVentaModel[]>([]);
  const [loadingRequest, setLoadingRequest] = useState<boolean>(true);
  const history = useHistory();

  useEffect(() => {
    const fetchPost = async () => {
      const res = await getAllPuntosVenta()
        .then()
        .catch((error) => {
          history.push("/error/500");
        });
      if (res) {
        setShiftList(res);
        setLoadingRequest(false);
      }
    };
    fetchPost();
  }, [reload]);

  return { shiftList, loadingRequest };
};
